import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import list from '@/components/list'
import search from '@/components/search'
Vue.prototype.OpenLink = function (_url) { _url.indexOf('http') == -1 ? '' : window.open(_url) }
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/m/html/rgznyxx/',
  fullPath: '',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index.html',
      name: 'index',
      component: index
    },
    {
      path: '/list.html',
      name: 'list',
      component: list
    },
    {
      path: '/search.html',
      name: 'search',
      component: search
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js